import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../services/api";

const name = "getFeedbackOptions";
const initialState = createInitialState();

function createInitialState() {
  return {
    done: false,
    error: false,
    spinner: false,
    getFeedbackOptions: null,
  };
}

export const getFeedbackOptions = createAsyncThunk(
  "getFeedbackOptions",
  async (id, rejectWithValue) => {
    try {
      const response = await api.get(`/api/feedback/get/options/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'An error occurred');
    }
  }
);



const getFeedbackOptionsSlice = createSlice({
  name: name,
  initialState,
  reducers: {
    resetGetFeedbackOptions: (state) => {
      state.done = false;
      state.error = false;
      state.spinner = false;
      state.getFeedbackOptions = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getFeedbackOptions.pending, (state) => {
        state.spinner = true;
        state.error = false;
      })
      .addCase(getFeedbackOptions.fulfilled, (state, action) => {
        state.done = true;
        state.spinner = false;
        state.error = false;
        state.getFeedbackOptions = action.payload;
      })
      .addCase(getFeedbackOptions.rejected, (state, action) => {
        state.done = false;
        state.spinner = false;
        state.error = action.payload;
      });
  },
});

export const { resetGetFeedbackOptions } = getFeedbackOptionsSlice.actions;
export const getFeedbackOptionsReducer = getFeedbackOptionsSlice.reducer;
